import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { message, notification } from 'antd';

const loginPath = '/user/login';

// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  error?: string;
  errorCode?: number;
  errorMessage?: string;
}

/**
 * @name 错误处理
 * 适配 BitLand 后端 API 的错误处理
 * @doc https://umijs.org/docs/max/request#配置
 */
declare const API_BASE_URL: string;

export const errorConfig: RequestConfig = {
  baseURL: API_BASE_URL || '',
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { success, error: errorMsg, errorMessage } =
        res as unknown as ResponseStructure;
      if (!success) {
        const error: any = new Error(errorMsg || errorMessage || '请求失败');
        error.name = 'BizError';
        error.info = { errorMessage: errorMsg || errorMessage };
        throw error;
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.name === 'BizError') {
        const errorInfo = error.info;
        if (errorInfo) {
          message.error(errorInfo.errorMessage || '请求失败');
        }
      } else if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          // Token 过期或无效，清除登录状态并跳转到登录页
          localStorage.removeItem('bitland_crm_token');
          localStorage.removeItem('bitland_crm_user');
          if (window.location.pathname !== loginPath) {
            history.push(loginPath);
          }
          return;
        }
        if (status === 403) {
          message.error('没有权限访问');
        } else if (status === 404) {
          message.error('请求的资源不存在');
        } else if (status === 429) {
          message.error('请求过于频繁，请稍后再试');
        } else {
          message.error(`请求失败 (${status})`);
        }
      } else if (error.request) {
        message.error('网络异常，请检查后端服务是否启动');
      } else {
        message.error('请求异常，请重试');
      }
    },
  },

  // 请求拦截器：自动携带 JWT Token
  requestInterceptors: [
    (config: RequestOptions) => {
      const token = localStorage.getItem('bitland_crm_token');
      if (token) {
        const headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
        return { ...config, headers };
      }
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      return response;
    },
  ],
};
